// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Toast from "./Toast.bs.jsx";
import * as React from "react";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as TiliaReact from "@tilia/react/src/TiliaReact.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import ToastBannerModuleCss from "./ToastBanner.module.css";

let classes = ToastBannerModuleCss;

let buttonCloseText = "Zavřít";

let closeButtonPlaceholder = "\xA0".repeat((buttonCloseText.length << 1));

let make = React.memo(props => {
  TiliaReact.useTilia();
  let messages = Toast.tree.toasts;
  if (messages.length !== 0) {
    return <div
      className={classes.toastBanner}
    >
      {messages.map(message => {
        let match;
        switch (message.TAG) {
          case "Error" :
            match = [
              `error`,
              `alert`
            ];
            break;
          case "Info" :
            match = [
              `info`,
              `status`
            ];
            break;
          case "Success" :
            match = [
              `success`,
              `status`
            ];
            break;
        }
        let id = message.id;
        return React.cloneElement(<div
          key={id} 
          role={match[1]}
        >
          <div>
            {message.message}
            {closeButtonPlaceholder}
            <button
              className={Styles.link.base + ` ` + classes.buttonClose}
              type={"button"}
              onClick={param => Toast.removeMessage(id)}
            >
              {buttonCloseText}
            </button>
          </div>
        </div>, {
          "data-variant": match[0]
        });
      })}
    </div>;
  } else {
    return null;
  }
});

export {
  classes,
  buttonCloseText,
  closeButtonPlaceholder,
  make,
}
/* classes Not a pure module */
